module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg2.6fe8be00.png";